module.exports = __webpack_public_path__ + "img/trip_sendai11.6fe54e24.jpg";